import { render, staticRenderFns } from "./ProductRelated.vue?vue&type=template&id=43ce62c5&lang=pug"
import script from "./ProductRelated.vue?vue&type=script&lang=js"
export * from "./ProductRelated.vue?vue&type=script&lang=js"
import style0 from "./ProductRelated.vue?vue&type=style&index=0&id=43ce62c5&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/andrewatieh/WebstormProjects/JTCoffeeTheme/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('43ce62c5')) {
      api.createRecord('43ce62c5', component.options)
    } else {
      api.reload('43ce62c5', component.options)
    }
    module.hot.accept("./ProductRelated.vue?vue&type=template&id=43ce62c5&lang=pug", function () {
      api.rerender('43ce62c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/scripts/components/product/ProductRelated.vue"
export default component.exports